/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Select } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DPIAService from '../../../services/DPIA.service';
import { useDpiaContext } from '../dpia.context';
import { checkValidForm } from './Step1';

const ModalDataflow = ({ form }) => {
    const { t } = useTranslation(['translation', 'dpia']);
    const { setDataflow, setError, error } = useDpiaContext();

    const [dataFlowOptions, setDataFlowOptions] = useState([]);

    useEffect(() => {
        const getDataFlow = async () => {
            try {
                const { data } = await DPIAService.getDPIADataFlow();
                if (data?.resultData) {
                    setDataFlowOptions(data?.resultData);
                    setDataflow(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getDataFlow();
    }, []);

    const onValuesChange = (_, allValues) => {
        const fields = ['dataflowList'];
        const check = checkValidForm(fields, allValues);
        setError(!check);
    };

    useEffect(() => {
        if (error) {
            form.validateFields();
        }
    }, [error, form]);

    return (
        <>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                name="dataflowList"
                form={form}
                layout="vertical"
                onValuesChange={onValuesChange}
            >
                <Form.Item
                    name="dataflowList"
                    // className="my-8"
                    label={t('Search for job names data codes')}
                    rules={[
                        {
                            required: true,
                            message: t('Please add related dataflow tasks', {
                                ns: 'dpia',
                            }),
                        },
                    ]}
                >
                    <Select
                        size="large"
                        mode="multiple"
                        placeholder={t('Search for job names data codes')}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            (option?.children ?? '')
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                    >
                        {dataFlowOptions.map((item) => (
                            <Select.Option
                                key={item.businessProcessId}
                                value={item.businessProcessId}
                            >
                                {item.businessProcessName}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </>
    );
};
export default ModalDataflow;
